import { type DocumentType, graphql } from '@generated/gql';

export const NotificationsFields = graphql(/** GraphQL */ `
  fragment NotificationsFields on Notification {
    id
    read
    title {
      ...NotificationTranslatedString
    }
    body {
      ...NotificationTranslatedString
    }
    linkText {
      ...NotificationTranslatedString
    }
    link
    createdAt
  }
`);

export const CustodianNotificationsFields = graphql(/** GraphQL */ `
  fragment CustodianNotificationsFields on CustodianNotification {
    id
    read
    title {
      ...CustodianTranslatedString
    }
    body {
      ...CustodianTranslatedString
    }
    linkText {
      ...CustodianTranslatedString
    }
    link
    createdAt
  }
`);

export const FETCH_NOTIFICATIONS = graphql(/** GraphQL */ `
  query notificationsFetchNotifications($input: FetchNotificationsInput!) {
    fetchNotifications(input: $input) {
      notifications {
        ...NotificationsFields
      }
      totalCount
    }
  }
`);

export const FETCH_CUSTODIAN_NOTIFICATIONS = graphql(/** GraphQL */ `
  query notificationsFetchCustodianNotifications(
    $input: FetchCustodianNotificationsInput!
  ) {
    fetchCustodianNotifications(input: $input) {
      totalCount
      notifications {
        ...CustodianNotificationsFields
      }
    }
  }
`);

export const MARK_READ = graphql(/** GraphQL */ `
  mutation notificationsMarkAsRead($input: MarkNotificationAsReadInput!) {
    markNotificationAsRead(input: $input)
  }
`);

export const MARK_ALL_READ = graphql(/** GraphQL */ `
  mutation notificationsMarkAllAsRead {
    markAllNotificationsAsRead
  }
`);

export type AppBarNotification =
  | DocumentType<typeof NotificationsFields>
  | DocumentType<typeof CustodianNotificationsFields>;
export type NotificationsQueryData = DocumentType<typeof FETCH_NOTIFICATIONS>;
export type CustodianNotificationsQueryData = DocumentType<
  typeof FETCH_CUSTODIAN_NOTIFICATIONS
>;
